import { CheckBox, Spacer, VDBText } from "@components/atoms";
import React, { useEffect, useState } from "react";
import styled from "styled-components/native";
import { Pressable } from "react-native";
import { Image as ExpoImage } from "expo-image";
import { useSelector } from "react-redux";
import { SpaceType } from "@components/atoms/Spacer/types";
import LabelView from "../LabelView";
import VDBIcon from "@components/icons/VDBIcon";
import { IconsVariant } from "@components/icons/VDBIcon";
import { useTheme } from "styled-components/native";
import { useTypographyStore } from "@redux/slices/typographySlice";
import { Menu, MenuItem, MenuItemLabel } from "@gluestack-ui/themed";
import { Platform } from "react-native";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import { PriceModes } from "../PriceModeCard/types";
import { GlobalEnum, ProductCategory } from "@utils/constants";
import EmptyImagePreview from "../GalleryView/utils/EmptyImage/EmptyImagePreview";
import { getShapeValue } from "../GalleryView/utils/EmptyImage/utils";
import Tooltip from "@components/atoms/Tooltip";
import { useUserCurrency } from "../../../hooks/getCurrency";
import useThreeDotMenuState from "../../../hooks/useThreeDotMenuState";
import { IconState } from "../IconUtils";
import { VDBIcons } from "@utils/VDBIcons";
import { getOptimizedListImageUrl, isImageUrlEmptyOrUndefined } from "../Utils";
import {
  getImageSource,
  getIOSImageProps,
  ImageSizePreset,
} from "@utils/image/imageOptimizer";
import { getDiamondValue } from "@utils/product/productFormatters";
import { getProductThemeFromType } from "@components/common/Header/utils";
import { SearchResultListTypes } from "./types";
import { useProductPrefix } from "../../../hooks/useProductPrefix";
import { useAnimation } from "../../../contexts/AnimationContext";
import { useNavigationHistory } from "../../../hooks/useNavigationHistory";
import { DeviceEventEmitter } from "react-native";
import { useIsFoldable } from "@navigations/utils/FoldableWrapper";
import { productLevelOneColor } from "@utils/product/productTheme";
import { FALLBACK_IMAGE_ASSET } from "@utils/product/searchResultConstants";
import { isPair } from "@utils/product/productValidators";
import { filterMenuOptions } from "../SearchResultGridItem/utils";

const topDetailsData = [
  {
    label: "Cut",
  },
  {
    label: "Pol",
  },
  {
    label: "Sym",
  },
  {
    label: "Fluor",
  },
];

const SearchResultListItem = ({
  listExpanded,
  mItem,
  menuOptions,
  menuOptionSelected,
  checkBoxSelection,
  ismItemChecked,
  productType,
  handleItemClick,
  favoriteClickedFunction,
}: SearchResultListTypes) => {
  const { addRouteToHistory } = useNavigationHistory();
  const userInfo = useUserInfo();
  const priceMode = userInfo?.user?.price_mode;
  const userCurrency = useUserCurrency();
  const productPrefix = useProductPrefix();
  const theme = useTheme();
  const { deviceWidth } = useIsFoldable();
  const screenWidth = deviceWidth - (theme.isMobile ? 24 : 32);
  const typography = useTypographyStore();
  const [showExpandedListView, setShowExpandedListView] =
    useState(listExpanded);
  const { triggerAnimation } = useAnimation();
  const showFavoritesAnimation = useSelector(
    (state: any) =>
      state.globalData?.app_settings?.showFavoritesAnimation ?? false
  );

  const [imageUri, setImageUri] = useState(getOptimizedListImageUrl(mItem));
  const [isFavorite, setIsFavorite] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isItemChecked, setIsItemChecked] = useState(
    mItem?.is_selected || ismItemChecked || false
  );
  const [showImageContainer, setShowImageContainer] = useState(
    !isImageUrlEmptyOrUndefined(mItem)
  );

  const [showErrorImage, setShowErrorImage] = useState(
    isImageUrlEmptyOrUndefined(mItem)
  );
  const [tooltipIsOpen, setTooltipIsOpen] = useState(false);
  const checkStateChanged = (checked: boolean) => {
    setIsItemChecked(checked);
    checkBoxSelection(checked, mItem);
  };

  useEffect(() => {
    setIsItemChecked(mItem?.is_selected || ismItemChecked || false);
  }, [ismItemChecked, mItem?.is_selected]);

  useEffect(() => {
    if (mItem?.is_favorite !== undefined) {
      setIsFavorite(mItem?.is_favorite);
    }
  }, [mItem?.is_favorite]);

  const getAvailabilityStatus = () => {
    switch (mItem?.available) {
      case GlobalEnum.OUT_ON_MEMO:
        return "error-01";
      case GlobalEnum.ON_HAND:
        return "success-01";
      case GlobalEnum.PLEASE_EMAIL:
      default:
        return "warn-01";
    }
  };
  const productTheme = getProductThemeFromType(productType);

  const {
    setThreeDotMenuOpen,
    setThreeDotIconState,
    handlePressIn,
    handlePressOut,
    getThreeDotIconBackgroundColor,
  } = useThreeDotMenuState(false);

  return (
    <Pressable
      onPress={() =>
        handleItemClick(
          mItem,
          productType,
          priceMode,
          productPrefix,
          addRouteToHistory
        )
      }
    >
      <ParentContainer
        theme={theme}
        isChecked={isItemChecked}
        productType={productType}
      >
        <FirstContainer>
          <ImageAndContentContainer>
            <ImageAndCheckboxContainer>
              {!userInfo?.isIFrame() && (
                <CheckBox
                  fillColor={theme["knob-bor"]}
                  checkBoxSize={20}
                  checkedFunction={checkStateChanged}
                  isChecked={isItemChecked}
                />
              )}
              <ImageResourceContainer>
                {showErrorImage ? (
                  <FallbackImageContainer theme={theme}>
                    <EmptyImagePreview
                      shape={getShapeValue(mItem)}
                      size={30}
                      isPair={isPair(mItem) ?? false}
                    />
                  </FallbackImageContainer>
                ) : showImageContainer ? (
                  <ExpoImage
                    style={{
                      height: 48,
                      width: 48,
                      borderRadius: 8,
                      borderColor: theme["core-03"],
                      borderWidth: 1,
                    }}
                    source={getImageSource(
                      imageUri,
                      ImageSizePreset.LIST_THUMB
                    )}
                    recyclingKey={`list-img-${mItem?.id}`}
                    contentFit="cover"
                    {...getIOSImageProps()}
                    {...(Platform.OS === "android" && {
                      cachePolicy: "disk",
                    })}
                    onError={() => {
                      if (mItem?.video_url) {
                        setShowImageContainer(false);
                      } else {
                        setShowErrorImage(true);
                        setShowImageContainer(false);
                        setImageUri(FALLBACK_IMAGE_ASSET);
                      }
                    }}
                  />
                ) : (
                  <VideoBackgroundContainer theme={theme}>
                    <VideoPlayIconContainer theme={theme}>
                      <VDBIcon
                        color={theme["core-06"]}
                        size={20}
                        variant={IconsVariant.VDBCustom}
                        name={VDBIcons.PLAY}
                      />
                    </VideoPlayIconContainer>
                  </VideoBackgroundContainer>
                )}
              </ImageResourceContainer>
              <AvailabilityDot bgColor={theme[getAvailabilityStatus()]} />
            </ImageAndCheckboxContainer>
            <FirstContentContainer>
              {mItem?.short_title && (
                <TitleContainer screenWidth={screenWidth}>
                  <VDBText
                    type={typography["Minor-M"]}
                    color={theme["core-05"]}
                    numberOfLines={2}
                    ellipsizeMode="tail"
                  >
                    {mItem?.short_title}
                  </VDBText>
                  <Spacer size={SpaceType.ExtraSmall} />
                </TitleContainer>
              )}
              <FirstContentMapContainer>
                {topDetailsData.map((item, index) => {
                  return (
                    <React.Fragment key={index}>
                      <LabelView
                        itemLeftText={item.label}
                        itemRightText={getDiamondValue(item.label, mItem)}
                        leftPostfixText=":"
                        keyTypographyStyle={typography["Minor-R"]}
                        valueTypographyStyle={typography["Minor-M"]}
                        allowSpaceAfterLeftText={false}
                      />
                      <Spacer
                        size={
                          theme.isMobile ? SpaceType.Tiny : SpaceType.ExtraSmall
                        }
                      />
                    </React.Fragment>
                  );
                })}
              </FirstContentMapContainer>
              <Spacer size={SpaceType.ExtraSmall} />
              <LabelView
                itemLeftText="Stock"
                itemRightText={getDiamondValue("Stock", mItem)}
                leftPostfixText="#"
                keyTypographyStyle={typography["Minor-R"]}
                valueTypographyStyle={typography["Minor-M"]}
              />
              <Spacer size={SpaceType.ExtraSmall} />
            </FirstContentContainer>
          </ImageAndContentContainer>

          <OptionsContainer>
            {!userInfo?.isIFrame() && (
              <Pressable
                onPress={(event) => {
                  if (!isFavorite && showFavoritesAnimation) {
                    if (
                      Platform.OS === "web" &&
                      theme.isLargeScreen &&
                      event.currentTarget
                    ) {
                      const rect = (
                        event.currentTarget as any
                      ).getBoundingClientRect();
                      const heartPosition = {
                        x: rect.left + rect.width / 2,
                        y: rect.top + rect.height / 2,
                      };

                      triggerAnimation(heartPosition);
                    }
                    DeviceEventEmitter.emit("animateFavoritesTab");
                  }

                  favoriteClickedFunction(isFavorite, mItem);
                }}
              >
                <VDBIcon
                  color={theme[isFavorite ? "error-01" : "core-06"]}
                  size={24}
                  variant={IconsVariant.VDBCustom}
                  name={isFavorite ? VDBIcons.FAV : VDBIcons.FAV_EMPTY}
                />
              </Pressable>
            )}

            {!isMenuOpen ? (
              <Pressable
                onPressIn={handlePressIn}
                onPressOut={handlePressOut}
                onPress={() => {
                  setIsMenuOpen(true);
                  setThreeDotMenuOpen(true);
                  setThreeDotIconState(IconState.Selected);
                }}
              >
                <VDBIcon
                  color={getThreeDotIconBackgroundColor(theme)}
                  size={24}
                  variant={IconsVariant.VDBCustom}
                  name={VDBIcons.DOTS_MENU_FILLED}
                />
              </Pressable>
            ) : (
              <Menu
                mt={Platform.OS === "ios" ? 0 : -15}
                py={0}
                useRNModal={false}
                marginRight={10}
                style={{
                  borderRadius: 8,
                  boxShadow: "2px 4px 8px rgba(0, 0, 0, 0.4)",
                }}
                shouldFlip={true}
                isOpen={true}
                onClose={() => {
                  setIsMenuOpen(false);
                  setThreeDotMenuOpen(false);
                  setThreeDotIconState(IconState.Unselected);
                }}
                trigger={({ ...triggerProps }) => (
                  <Pressable
                    onPressIn={handlePressIn}
                    onPressOut={handlePressOut}
                    onPress={() => {
                      setIsMenuOpen(false);
                      setThreeDotMenuOpen(false);
                      setThreeDotIconState(IconState.Unselected);
                    }}
                    {...triggerProps}
                  >
                    <VDBIcon
                      color={getThreeDotIconBackgroundColor(theme)}
                      size={24}
                      variant={IconsVariant.VDBCustom}
                      name={VDBIcons.DOTS_MENU_FILLED}
                    />
                  </Pressable>
                )}
              >
                {filterMenuOptions(menuOptions, userInfo)?.map(
                  (option, index) => (
                    <MenuItem
                      key={option.name}
                      textValue={option.label}
                      style={{ padding: 0 }}
                      onPress={() => {
                        setIsMenuOpen(false);
                        setThreeDotMenuOpen(false);
                        setThreeDotIconState(IconState.Unselected);
                        menuOptionSelected(option.name, mItem);
                      }}
                    >
                      <MenuItemContainer>
                        <MenuItemStyle>
                          <MenuItemLabel
                            fontSize={12}
                            fontWeight={"600"}
                            size="xs"
                            color={theme["core-06"]}
                          >
                            {option.label}
                          </MenuItemLabel>
                        </MenuItemStyle>
                        {index <
                          filterMenuOptions(menuOptions, userInfo).length -
                            1 && <LineView theme={theme} />}
                      </MenuItemContainer>
                    </MenuItem>
                  )
                )}
              </Menu>
            )}
          </OptionsContainer>
        </FirstContainer>
        <SecondContainer
          screenWidth={screenWidth}
          theme={theme}
          priceMode={priceMode}
        >
          <SecondContainerRow screenWidth={screenWidth} theme={theme}>
            <SecondContainerLevelFirst
              screenWidth={screenWidth * 0.42}
              theme={theme}
            >
              <LabelView
                itemLeftText="D"
                itemRightText={getDiamondValue("Depth", mItem)}
                leftPostfixText=":"
                keyTypographyStyle={typography["Minor-R"]}
                valueTypographyStyle={typography["Minor-M"]}
                allowSpaceAfterLeftText={false}
              />
              <Spacer size={SpaceType.Double} />
              <LabelView
                itemLeftText="T"
                itemRightText={getDiamondValue("Table", mItem)}
                leftPostfixText=":"
                keyTypographyStyle={typography["Minor-R"]}
                valueTypographyStyle={typography["Minor-M"]}
                allowSpaceAfterLeftText={false}
              />
            </SecondContainerLevelFirst>
            <Spacer size={SpaceType.Double} />
            <SecondContainerLevelTwo screenWidth={screenWidth * 0.49}>
              <Spacer size={SpaceType.Basic} />
              <LabelView
                itemLeftText="M"
                itemRightText={getDiamondValue("Meas", mItem)}
                leftPostfixText=":"
                keyTypographyStyle={typography["Minor-R"]}
                valueTypographyStyle={typography["Minor-M"]}
                cellWidth={screenWidth * 0.4}
                allowSpaceAfterLeftText={false}
              />
            </SecondContainerLevelTwo>
          </SecondContainerRow>

          {showExpandedListView && (
            <>
              <SecondContainerRow screenWidth={screenWidth}>
                <SecondContainerLevelFirst
                  screenWidth={screenWidth * 0.42}
                  theme={theme}
                >
                  <LabelView
                    itemLeftText="Ratio"
                    itemRightText={getDiamondValue("Ratio", mItem)}
                    leftPostfixText=":"
                    keyTypographyStyle={typography["Minor-R"]}
                    valueTypographyStyle={typography["Minor-M"]}
                    cellWidth={screenWidth * 0.24}
                    allowSpaceAfterLeftText={false}
                  />
                </SecondContainerLevelFirst>
                <Spacer size={SpaceType.Double} />
                <SecondContainerLevelTwo screenWidth={screenWidth * 0.49}>
                  <Spacer size={SpaceType.Basic} />
                  <LabelView
                    itemLeftText="Grdl"
                    itemRightText={getDiamondValue("Girdle", mItem)}
                    leftPostfixText=":"
                    keyTypographyStyle={typography["Minor-R"]}
                    valueTypographyStyle={typography["Minor-M"]}
                    cellWidth={screenWidth * 0.24}
                    allowSpaceAfterLeftText={false}
                  />
                </SecondContainerLevelTwo>
              </SecondContainerRow>
              <SecondContainerRow screenWidth={screenWidth}>
                <SecondContainerLevelFirst
                  screenWidth={screenWidth * 0.42}
                  theme={theme}
                >
                  <LabelView
                    itemLeftText="Crw"
                    itemRightText={getDiamondValue("Crown", mItem)}
                    leftPostfixText=":"
                    keyTypographyStyle={typography["Minor-R"]}
                    valueTypographyStyle={typography["Minor-M"]}
                    cellWidth={screenWidth * 0.24}
                    allowSpaceAfterLeftText={false}
                  />
                </SecondContainerLevelFirst>
                <Spacer size={SpaceType.Double} />
                <SecondContainerLevelTwo screenWidth={screenWidth * 0.49}>
                  <Spacer size={SpaceType.Basic} />
                  <LabelView
                    itemLeftText="Pav"
                    itemRightText={getDiamondValue("Pavilion", mItem)}
                    leftPostfixText=":"
                    keyTypographyStyle={typography["Minor-R"]}
                    valueTypographyStyle={typography["Minor-M"]}
                    cellWidth={screenWidth * 0.24}
                    allowSpaceAfterLeftText={false}
                  />
                </SecondContainerLevelTwo>
              </SecondContainerRow>
            </>
          )}

          {priceMode === PriceModes.WHITE && showExpandedListView && (
            <>
              <SecondContainerRow screenWidth={screenWidth}>
                <SecondContainerLevelFirst
                  screenWidth={screenWidth * 0.95}
                  theme={theme}
                >
                  <VDBText
                    color={theme["core-05"]}
                    type={typography["Minor-M"]}
                    numberOfLines={1}
                    ellipsizeMode="tail"
                  >
                    {getDiamondValue("SupplierName", mItem)}
                  </VDBText>
                </SecondContainerLevelFirst>
              </SecondContainerRow>
              <SecondContainerRow screenWidth={screenWidth}>
                <SecondContainerLevelFirst
                  screenWidth={screenWidth * 0.95}
                  theme={theme}
                >
                  <VDBText
                    color={theme["core-05"]}
                    type={typography["Minor-M"]}
                    numberOfLines={1}
                    ellipsizeMode="tail"
                  >
                    {getDiamondValue("Region", mItem)}
                  </VDBText>
                </SecondContainerLevelFirst>
              </SecondContainerRow>
            </>
          )}
        </SecondContainer>
        {priceMode !== PriceModes.GREEN && (
          <ThirdContainer
            theme={theme}
            listExpanded={listExpanded}
            viewAlign={
              mItem?.pricing_comment &&
              mItem?.pricing_comment?.length > 0 &&
              userInfo.user.price_mode === PriceModes.WHITE
                ? "space-between"
                : "flex-end"
            }
          >
            {mItem?.pricing_comment &&
              userInfo.user.price_mode === PriceModes.WHITE && (
                <ThirdIconContainer>
                  <Tooltip
                    isOpen={tooltipIsOpen}
                    setIsOpen={setTooltipIsOpen}
                    trigger={() => (
                      <VDBIcon
                        color={theme[productLevelOneColor(productType)]}
                        size={SpaceType.Big}
                        variant={IconsVariant.VDBCustom}
                        name={VDBIcons.PRICE_COMMENT}
                      />
                    )}
                    tooltipBackgroundColor={theme["over-01"]}
                    popoverBackdropColor={"transparent"}
                  >
                    <VDBText
                      color={theme["core-01"]}
                      type={typography["Minor-R"]}
                    >
                      {mItem?.pricing_comment}
                    </VDBText>
                  </Tooltip>
                </ThirdIconContainer>
              )}
            <PriceMainContainer>
              <ThirdContainerCell width={88}>
                <ThirdContainerLabel width={88}>
                  <VDBText
                    color={theme["core-06"]}
                    type={typography["Minor-R"]}
                  >
                    P/ct:
                  </VDBText>
                </ThirdContainerLabel>
                <ThirdContainerValue width={88}>
                  <VDBText
                    color={theme["core-05"]}
                    type={typography["Minor-M"]}
                  >
                    {getDiamondValue("P/ct", mItem, userCurrency)}
                  </VDBText>
                </ThirdContainerValue>
              </ThirdContainerCell>

              {priceMode === PriceModes.WHITE &&
                !mItem?.is_fancy &&
                ![ProductCategory.LAB_GROWN_DIAMOND].includes(productType) && (
                  <ThirdContainerCell width={70}>
                    <ThirdContainerLabel width={70}>
                      <VDBText
                        color={theme["core-06"]}
                        type={typography["Minor-R"]}
                      >
                        Disc:
                      </VDBText>
                    </ThirdContainerLabel>
                    {!mItem?.is_fancy && (
                      <ThirdContainerValue width={70}>
                        <VDBText
                          color={theme["core-05"]}
                          type={typography["Minor-M"]}
                        >
                          {getDiamondValue("discountPercent", mItem)}
                        </VDBText>
                      </ThirdContainerValue>
                    )}
                  </ThirdContainerCell>
                )}

              <ThirdContainerCell width={88}>
                <ThirdContainerLabel width={88}>
                  <VDBText
                    color={theme["core-06"]}
                    type={typography["Minor-R"]}
                  >
                    Total:
                  </VDBText>
                </ThirdContainerLabel>
                <ThirdContainerValue width={88}>
                  <VDBText
                    color={theme["core-05"]}
                    type={typography["Minor-M"]}
                  >
                    {getDiamondValue("totalPrice", mItem, userCurrency)}
                  </VDBText>
                </ThirdContainerValue>
              </ThirdContainerCell>
            </PriceMainContainer>
          </ThirdContainer>
        )}

        <Pressable
          onPress={() => setShowExpandedListView(!showExpandedListView)}
        >
          <FourthContainer theme={theme} productTheme={productTheme}>
            <VDBIcon
              color={theme[`${productTheme}-06`]}
              name={
                showExpandedListView ? VDBIcons.ARROW_UP : VDBIcons.ARROW_DOWN
              }
              variant={IconsVariant.VDBCustom}
              size={24}
            />
          </FourthContainer>
        </Pressable>
      </ParentContainer>
    </Pressable>
  );
};

const ParentContainer = styled.View<any>`
  height: auto;
  width: auto;
  border-radius: 8px;
  border-color: ${({ theme, isChecked, productType }) =>
    theme[
      isChecked
        ? productType === ProductCategory.DIAMOND
          ? "diam-04"
          : "lab-04"
        : "core-03"
    ]};
  border-width: ${({ isChecked }) => (isChecked ? 2 : 1)}px;
`;

const FirstContainer = styled.View<any>`
  height: auto;
  width: auto;
  background-color: ${({ theme }) => theme["core-01"]};
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  flex-direction: row;
  justify-content: space-between;
`;

const FirstContentContainer = styled.View`
  margin-top: 4px;
  margin-start: 4px;
`;

const FirstContentMapContainer = styled.View`
  flex-direction: row;
`;

const OptionsContainer = styled.View`
  height: auto;
  width: 24px;
  flex_direction: column;
  justify-content: space-between;
  margin-right: 10px;
  margin-top: 8px;
  margin-bottom: 8px;
`;

const ImageAndCheckboxContainer = styled.View<any>`
  height: 76px;
  width: 84px;
  background-color: ${({ theme }) => theme["core-01"]};
  border-top-left-radius: 8px;
  justify-content: center;
  align-items: center;
  padding-left: 8px;
  flex-direction: row;
`;

const ImageAndContentContainer = styled.View<any>`
  flex-direction: row;
`;

const ImageResourceContainer = styled.View`
  padding-left: 2px;
`;

const FallbackImageContainer = styled.View<any>`
  width: 48px;
  height: 48px;
  background-color: ${({ theme }) => theme["core-01"]};
  border-radius: 8px;
  justify-content: center;
  align-items: center;
  border-color: ${({ theme }) => theme["core-03"]};
  border-width: 1px;
`;

const SecondContainer = styled.View<any>`
  height: auto;
  width: auto;
  background-color: ${({ theme }) => theme["core-02"]};
  align-items: center;
  border-bottom-left-radius: ${({ priceMode }) =>
    priceMode === PriceModes.GREEN ? 8 : 0}px;
  border-bottom-right-radius: ${({ priceMode }) =>
    priceMode === PriceModes.GREEN ? 8 : 0}px;
`;

const SecondContainerLevelFirst = styled.View<any>`
  height: 24px;
  width: ${({ screenWidth }) => screenWidth}px;
  flex-direction: row;
  align-items: center;
`;

const SecondContainerLevelTwo = styled.View<any>`
  height: 24px;
  width: ${({ screenWidth }) => screenWidth}px;
  flex-direction: row;
  align-items: center;
`;

const SecondContainerRow = styled.View<any>`
  height: 24px;
  width: auto;
  background-color: ${({ theme }) => theme["core-02"]};
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const ThirdContainer = styled.View<any>`
  height: 52px;
  width: auto;
  background-color: ${({ theme }) => theme["core-01"]};
  flex-direction: row;
  align-items: center;
  justify-content: ${({ viewAlign }) => viewAlign};
  border-bottom-left-radius: ${({ listExpanded }) => (listExpanded ? 8 : 0)}px;
  border-bottom-right-radius: ${({ listExpanded }) => (listExpanded ? 8 : 0)}px;
`;

const ThirdIconContainer = styled.View`
  height: 24px;
  width: 24px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-start: 20px;
`;

const FourthContainer = styled.View<{
  productTheme: string;
}>`
  height: 24px;
  width: auto;
  background-color: ${({ theme, productTheme }) => theme[`${productTheme}-03`]};
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  align-items: center;
  justify-content: center;
`;

const PriceMainContainer = styled.View`
  height: 52px;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  margin-end: 10px;
`;

const ThirdContainerCell = styled.View<any>`
  flex-direction: column;
  width: ${({ width }) => width}px;
`;

const ThirdContainerLabel = styled.View<any>`
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  width: ${({ width }) => width}px;
`;

const ThirdContainerValue = styled.View<any>`
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  width: ${({ width }) => width}px;
`;

const TitleContainer = styled.View<any>`
  min-height: 26px;
  width: ${({ screenWidth }) => screenWidth / 2}px;
  justify-content: flex-end;
`;

const LineView = styled.View<any>`
  height: 1px;
  background-color: ${({ theme }) => theme["core-03"]};
  width: auto;
`;

const MenuItemStyle = styled.View`
  border-color: #000000;
  width: 200px;
  padding: 10px;
`;

const AvailabilityDot = styled.View<any>`
  height: 8px;
  width: 8px;
  border-radius: 4px;
  border: 1px;
  border-color: ${({ theme }) => theme["cont-00"]};
  background-color: ${({ bgColor }) => bgColor};
  position: absolute;
  top: 54px;
  left: 36px;
`;

const VideoPlayIconContainer = styled.View<any>`
  height: 28px;
  width: 28px;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: ${({ theme }) => theme["over-02"]};
  border-radius: 14px;
`;

const VideoBackgroundContainer = styled.View<any>`
  height: 48px;
  width: 48px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme["core-01"]};
`;

const MenuItemContainer = styled.View`
  width: 200px;
`;

export default SearchResultListItem;
